<div class="flex-main-container">
  <div class="container main-container">
    <div class="row">
      <div class="col-xs-12">
        <h1>{{ confirmationHeader.title }}</h1>
      </div>
    </div>
    <div class="row main-content">
      <div class="col-xs-12">{{ confirmationHeader.description }}</div>
      <div class="col-xs-12 entitlements">
        <div *ngFor="let assignedEntitlement of assignedEntitlements" class="row entitlement">
          <div class="col-xs-12 entitlement-info">
            <span
              *ngIf="assignedEntitlement.status === 200"
              class="di di16"
              [ngClass]="assignedEntitlement.icon">
            </span>
            <span
              *ngIf="assignedEntitlement.status !== 200"
              class="di di-alert">
            </span>
            <span
              class="guestSensitive"
              *ngIf="assignedEntitlement.status === 200">
              {{assignedEntitlement.guest}}
            </span>
            <span
              class="error-message"
              *ngIf="assignedEntitlement.status !== 200">
              {{ 'confirmation-page.error.' + assignedEntitlement.type | translate }}
            </span>
          </div>
          <div class="col-xs-12">
            <span>{{ 'confirmation-page.id-number' | translate }}</span>
            <span class="guestSensitive entitlementId">{{assignedEntitlement.entitlementId}}</span>
          </div>
          <div class="col-xs-12 product-name" aria-hidden="true">{{assignedEntitlement.productName}}</div>
          <h2 class="sr-only">{{ assignedEntitlement | productAddonsSRLabel: translatePipe }}</h2>
          <div *ngIf="assignedEntitlement.supplements" class="supplement" aria-hidden="true">
            <span class="addon-title">{{ 'confirmation-page.addons-label' | translate }}&nbsp;</span>
            <span class="addon-names">{{ getAddOnNames(assignedEntitlement.supplements) }}</span>
          </div>
          <div class="col-xs-12 entitlement-is-owned"
               *ngIf="assignedEntitlement.isOwned && assignedEntitlement.status === 200">
            <span class="di di16 di-checkmark"></span>
            <span> {{ 'confirmation-page.primaryGuestResponsible' | translate }} </span>
          </div>
        </div>
      </div>
      <div class="col-xs-12 passport-renew">
        {{ 'confirmation-page.renew-passports' | translate }}
        <a href="{{ 'confirmation-page.renew-passports-link' | translate }}"
           analyticsTrackLink='{"linkId":"{{&apos;{{&apos;}}LOB}}_TicketAPSpecialEventClaim_APRenew","store":"{{&apos;{{&apos;}}LOB}}{{&apos;{{&apos;}}storeType}}"}'>
          {{ 'confirmation-page.renew-passports-cta' | translate }}
        </a>
      </div>
      <div class="col-xs-12 next-actions">
        <div class="inner-border"></div>
        <div class="row">
          <div class="col-xs-12">
            <h2>{{ 'confirmation-page.whats-next.title' | translate }}</h2>
            <span>{{ 'confirmation-page.whats-next.description' | translate }}</span>
          </div>
          <div class="col-xs-12">
            <a *ngFor="let contentBlock of whatsNextData"
               [href]="contentBlock.link | translate"
               class="col-xs-12 action"
               analyticsTrackLink='{"linkId":"{{&apos;{{&apos;}}LOB}}_TicketAPSpecialEventClaim_{{ contentBlock.title | onlyletters }}","store":"{{&apos;{{&apos;}}LOB}}{{&apos;{{&apos;}}storeType}}"}'>
              <div class="hidden-xs icon">
                <span class="di di28" [ngClass]="contentBlock.icon | translate"></span>
              </div>
              <div class="col-xs-12 col-sm-9 content">
                <div>{{contentBlock.title | translate }}</div>
                <div>{{contentBlock.description | translate }}</div>
              </div>
              <div class="hidden-xs text-right continue-button">
                <span class="di di20 di-next-2"></span>
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
  <app-pep-syndicated-footer></app-pep-syndicated-footer>
  <div class="container-fluid navbar-fixed-bottom">
    <div class="container">
      <div class="row">
        <div class="col-xs-12 text-right">
          <wdpr-button theme="primary"
                       (click)="redirectUserToEntryPointPage()">{{ 'confirmation-page.done-cta' | translate }}
          </wdpr-button>
        </div>
      </div>
    </div>
  </div>
</div>
